import { axiosTokenInstance } from 'src/utils/axiosInstance.utils';
import { apiUrls } from 'src/utils/properties.utils';

export type SubscriptionStatusResponse = {
  status?: string;
  paidUserCount?: number;
};

export const getSubscriptionStatus =
  async (): Promise<SubscriptionStatusResponse | null> => {
    const response = await axiosTokenInstance.get(apiUrls.SUBSCRIPTION_STATUS);

    return response.data?.data || null;
  };
